import { Directive, inject, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { RestClient, User } from '../Api/DcoApi/Client/RestClient';

export const authGuard: CanActivateFn = async (route, state) => {
  var Client: RestClient = new RestClient();
  const router = inject(Router);

  try {
    // Hier wartet der Guard auf dein Promise
    const token = await Client.GetTocken();

    if (token === undefined || token === null || token === '') {
      return router.navigateByUrl('/challenge');
    }

    if (User.AdminOnly) {
      return true;
    } else {
      // Weiterleitung bei fehlender Berechtigung
      return router.navigateByUrl('/login?qr=' + btoa(state.url));
    }
  } catch (error) {
    // Fehlerfall (z.B. API-Fehler)
    return router.navigateByUrl('/login?qr=' + btoa(state.url));
  }
};

export const isAuthGuard: CanActivateFn = async (route, state) => {
  var Client: RestClient = new RestClient();
  const router = inject(Router);

  try {
    // Hier wartet der Guard auf dein Promise
    const token = await Client.GetTocken();

    if (token === undefined || token === null || token === '') {
      return router.navigateByUrl('/challenge');
    }

    if (User.Rolle && User.Rolle != "") {
      return true;
    } else {
      // Weiterleitung bei fehlender Berechtigung
      return router.navigateByUrl('/login?qr=' + btoa(state.url));
    }
  } catch (error) {
    // Fehlerfall (z.B. API-Fehler)
    return router.navigateByUrl('/login?qr=' + btoa(state.url));
  }
};

@Directive({
  selector: '[IsAdmin]',
  standalone: true
})
export class IsAdminDirective implements OnInit {
   Client: RestClient = new RestClient();
  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() {
    // Die Direktive fragt den Service direkt nach dem Status
    this.Client.GetTocken().then(token => {
      if (token === undefined || token === null || token === '') {
        this.viewContainer.clear();
      }

      if (User.AdminOnly) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });


  }
}


@Directive({
  selector: '[IsVolleBerechtigung]',
  standalone: true
})
export class IsVolleBerechtigung implements OnInit {
  Client: RestClient = new RestClient();
  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() {
    // Die Direktive fragt den Service direkt nach dem Status
    this.Client.GetTocken().then(token => {
      if (token === undefined || token === null || token === '') {
        this.viewContainer.clear();
      }

      if (User.HatVolleBerechtigung) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });


  }
}

@Directive({
  selector: '[IsSupervisor]',
  standalone: true
})
export class IsSupervisorDirective implements OnInit {
  Client: RestClient = new RestClient();
  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() {
    // Die Direktive fragt den Service direkt nach dem Status
    this.Client.GetTocken().then(token => {
      if (token === undefined || token === null || token === '') {
        this.viewContainer.clear();
      }

      if (User.HatSupervisorBerechtigung) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });


  }
}

@Directive({
  selector: '[IsManagement]',
  standalone: true
})
export class IsManagementDirective implements OnInit {
  Client: RestClient = new RestClient();
  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() {
    // Die Direktive fragt den Service direkt nach dem Status
    this.Client.GetTocken().then(token => {
      if (token === undefined || token === null || token === '') {
        this.viewContainer.clear();
      }

      if (User.HatManagementBerechtigung) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });


  }
}

@Directive({
  selector: '[IsSpezialUser]',
  standalone: true
})
export class IsSpezialUserDirective implements OnInit {
  Client: RestClient = new RestClient();
  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() {
    // Die Direktive fragt den Service direkt nach dem Status
    this.Client.GetTocken().then(token => {
      if (token === undefined || token === null || token === '') {
        this.viewContainer.clear();
      }

      if (User.HatSpezialUserBerechtigung) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });


  }
}


@Directive({
  selector: '[IsWelcomeCall]',
  standalone: true
})
export class IsWelcomeCallDirective implements OnInit {
  Client: RestClient = new RestClient();
  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() {
    // Die Direktive fragt den Service direkt nach dem Status
    this.Client.GetTocken().then(token => {
      if (token === undefined || token === null || token === '') {
        this.viewContainer.clear();
      }

      if (User.HatWelcomeCallBerechtigung) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });


  }
}




@Directive({
  selector: '[IsHatWelcomeCallBerechtigungWithoutSpezialUser]',
  standalone: true
})
export class IsHatWelcomeCallBerechtigungWithoutSpezialUserDirective implements OnInit {
  Client: RestClient = new RestClient();
  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() {
    // Die Direktive fragt den Service direkt nach dem Status
    this.Client.GetTocken().then(token => {
      if (token === undefined || token === null || token === '') {
        this.viewContainer.clear();
      }

      if (User.HatWelcomeCallBerechtigungWithoutSpezialUser) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });


  }
}
